<template>
  <div class="form-upload">
    <FormTitle
      :required="Boolean(data.is_must_answer)"
      :title="data.title"
      :desc="data.title_details"
      style="margin-bottom: 10px"
    />
    <p class="tips" v-if="data.tips">{{data.tips}}</p>
    <gkFormCustomGroup
      :class="['form-group', errTip ? 'hide-err' : '']"
      :field="data.id.toString()"
      :rule="isValidity ? rules : []"
      :validity="isValidity"
      target="[]"
      v-model="answers"
    >
      <div class="file" :class="{'hide': fileList.length === maxLength}">
        <div class="file-wrap" @click="doUpload">
          <i class="iconfont">&#xe63e;</i>
          请选择文件，每个文件限制 {{fileMaxSize / 1024}}M 内
        </div>
        <GkUpload
          ref="gkUpload"
          class="file-input"
          alias="file"
          url=""
          :multiple="true"
          @change="addFiles"
        />
      </div>
      <div class="err-tip" v-if="errTip">{{errTip}}</div>
    </gkFormCustomGroup>

    <div class="file-list-wrap" v-if="fileList.length > 0">
      <FileItem v-for="item in fileList"
        :itemInfo="item"
        :fileMaxSize="fileMaxSize"
        :fileType="fileType"
        :key="item.uid"
        @remove="removeFile"
        @reUpload="openUpload"
      />
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import eventService from '../../../../service/event.service'

import GkUpload from 'gkui/upload'
import gkFormCustomGroup from 'gkui/form/FormCustomGroup'
import FormTitle from '@/components/FormTitle'
import FileItem from './FileItem'

import utils from '../../../../utils'

import config from '@/config'

export default {
  name: 'upload',
  props: {
    data: VueTypes.object.def({})
  },
  components: {
    FormTitle,
    GkUpload,
    gkFormCustomGroup,
    FileItem
  },
  data () {
    return {
      answers: [],
      type_id: this.$route.query.id,
      imgSrc: '',
      url: '',
      fileList: [],
      maxLength: 0,
      errTip: '',
      keys: [],
      reUploadFile: null,
      previewImg: '',

      dataConcatStr: config.dataConcatStr
    }
  },
  created () {
    this.maxLength = this.data.details.options.length
    this.getKeysList()
  },
  computed: {
    options () {
      return this.data.details.options
    },
    fileType () {
      return this.options[0].file_type
    },
    fileMaxSize () {
      return this.options[0].file_max_size
    },
    testType () {
      let that = this
      return {
        type (file) {
          let name = file.name.toLowerCase()
          let type = name.substring(name.lastIndexOf('.') + 1)
          let fileType = that.fileType

          if (fileType === 'image') {
            return /(png|gif|jpg|jpeg|bmp|webp)/.test(type)
          }
          if (fileType === 'video') {
            return /(rmvb|mp4|3gp|avi|mpeg|rm|flv|mov)/.test(type)
          }
          if (fileType === 'document') {
            // return /(doc|docx|xls|xlsx|txt|pdf)/.test(type)
            return /(pptx|ppt|pdf)/.test(type)
          }
        },
        size (file) {
          let size = that.fileMaxSize * 1000
          return file.size < size
        }
      }
    },
    errMessage () {
      return {
        type: '文件格式不正确，请检查',
        size: '文件过大，请检查'
      }
    },
    rules () {
      let rule = []
      if (this.data.is_must_answer) {
        rule.push({
          required: '请选择文件'
        })
      }
      return rule
    },
    isValidity () {
      return Boolean(this.data.showQuestion)
    }
  },
  watch: {
    fileList: {
      handler: function (list) {
        // 每次有更新先把答案置空
        let _answer = []

        for (let i = 0; i < list.length; i++) {
          // 如果有上传文件状态不成功，则退出，不收集答案
          if (list[i].status !== 'success') {
            continue
          } else {
            // 上传全部成功，收集key，id，type
            _answer.push(`${list[i].postData.key}${this.dataConcatStr}${list[i].id}${this.dataConcatStr}${this.data.type}`)
          }
        }
        this.answers = _answer
      },
      deep: true
    }
  },
  methods: {
    // 重新上传
    openUpload (oldFile) {
      this.reUploadFile = oldFile
      this.$nextTick(() => {
        this.$refs.gkUpload.handleProxyClick()
      })
    },
    // 普通上传
    doUpload () {
      this.reUploadFile = null
      this.$nextTick(() => {
        this.$refs.gkUpload.handleProxyClick()
      })
    },
    // 获取每个option的key
    getKeysList () {
      this.options.forEach(option => {
        let params = {
          key: option.key,
          status: false
        }
        this.keys.push(params)
      })
    },
    async addFiles (files) {
      // 错误提示置空
      this.errTip = ''

      // 校验上传的文件格式
      let validateResult = this.validateFiles(files)

      if (!validateResult) return

      let newLength = this.fileList.length + files.length
      if (this.reUploadFile) {
        newLength = newLength - 1
      }

      if (newLength > this.maxLength) {
        this.errTip = `最多上传 ${this.maxLength} 个文件`
        return
      }

      // 转换成formData，上传
      let postFileList = Array.prototype.slice.call(files)

      postFileList.forEach(async file => {
        let fileInfo = await this.handleStart(file)
        let formData = this.formatData(file)

        this.uploadFile(formData, fileInfo)
      })
      this.$refs.gkUpload.clear()
    },
    // 上传
    uploadFile (file, fileInfo) {
      eventService.uploadFile(file).then(res => {
        this.handleSuccess(res, fileInfo)
      }).catch(() => {
        this.handleError(fileInfo)
      })
    },
    async handleStart (file) {
      let _index = -1
      let previewImg = ''

      if (this.reUploadFile) {
        _index = this.fileList.findIndex(item => item.uid === this.reUploadFile.uid)
        this.resetKeysStatus(this.reUploadFile)
      }

      if (this.fileType === 'image') {
        previewImg = await this.getPreviewImg(file)
      }
      for (let index = 0; index < this.keys.length; index++) {
        if (!this.keys[index].status) {
          const _file = {
            uid: utils.guid(),
            name: file.name,
            size: file.size,
            preview: previewImg,
            status: 'uploading',
            id: -1,
            postData: {
              key: this.keys[index].key
            }
          }
          this.keys[index].status = true

          if (this.reUploadFile) {
            this.fileList.splice(_index, 1, _file)
            this.reUploadFile = null
          } else {
            this.fileList.push(_file)
          }
          return _file
        }
      }
    },
    getPreviewImg (file) {
      return new Promise(resolve => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.addEventListener('load', () => {
          resolve(reader.result)
        })
      })
    },
    // 上传成功，修改状态为 success,并给id赋值
    handleSuccess (res, file) {
      const _index = this.fileList.findIndex(item => item.uid === file.uid)
      const _file = this.fileList.find(item => item.uid === file.uid)
      if (_file) {
        _file.status = 'success'
        _file.id = res.id
      }
      this.fileList[_index] = {...this.fileList[_index], ..._file}
    },
    // 上传失败，修改状态为fail
    handleError (file) {
      const _index = this.fileList.findIndex(item => item.uid === file.uid)
      this.fileList[_index].status = 'fail'
    },
    /**
     * @func formatData
     * @desc 整理上传的数据
     * @param  {Object} file       上传的文件数据
     * @param  {String} file.name  上传的文件名称
     * @param  {String} file.type  上传的文件类型
     * @param  {Number} file.size  上传的文件大小
     */
    formatData (file, i) {
      let form = new FormData()
      let params = {
        type: 2,
        type_id: +this.type_id, // 活动id
        question_id: this.data.id // 题目id
      }

      this.fileList[this.fileList.length - 1].postData = {
        ...this.fileList[this.fileList.length - 1].postData,
        ...params
      }
      let postData = this.fileList[this.fileList.length - 1].postData

      form.append('file', file, encodeURIComponent(file.name))
      Object.keys(postData).forEach(key => {
        form.append(key, postData[key])
      })
      return form
    },
    // 校验
    validateFiles (files) {
      let valid = true
      let fileList = Array.prototype.slice.call(files)

      for (let i = 0; i < fileList.length; i++) {
        Object.keys(this.testType).forEach(key => {
          if (valid) {
            const result = this.testType[key](fileList[i])

            if (!result) {
              valid = false
              this.errTip = this.errMessage[key]
            }
          }
        })

        if (!valid) {
          return false
        }

        return true
      }
    },
    // 删除文件，并将消耗掉的key状态重置
    removeFile (data) {
      const _index = this.fileList.findIndex(item => item.uid === data.uid)
      this.resetKeysStatus(data)
      this.fileList.splice(_index, 1)
      data.id > 0 && eventService.deleteFile({id: +data.id})
    },
    resetKeysStatus (item) {
      for (let i = 0; i < this.keys.length; i++) {
        if (item.postData.key === this.keys[i].key) {
          this.keys[i].status = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/_common";

.form-upload {
  position: relative;

  & .tips {
    margin: -2px 0 24px 12px;
    @include lineFont(14, 400);

    @include isMobile {
      line-height: 20px;
    }
  }

  & .err-tip {
    position: absolute; bottom: 20px; left: 0;
    // margin-bottom: 20px;
    color: #F92A0E;
    @include lineFont(14, 400);
  }

  & .file-list-wrap {
    // padding-top: 16px;
  }

  & .form-group {
    padding-bottom: 16px;

    & ::v-deep .gkui-form-error {
      bottom: -14px;
    }
    &.hide-err {
      padding-bottom: 50px;
      & ::v-deep .gkui-form-error {
        display: none;
      }
    }
  }

  & .file {
    position: relative;
    width: 100%; height: 64px;
    text-align: center;
    border: 2px dashed rgba(226,226,226,1);
    border-radius: 4px;
    transition: all .3s;

    &.hide {
      position: absolute; z-index: -999;
      left: -999px;
      opacity: 0;
    }

    @include isMobile {
      height: 50px;
    }

    &:hover {
      border-color: #729BE5;
      & .file-wrap {
        color: #1458D4;
      }
    }

    & .file-wrap {
      display: flex; align-items: center; justify-content: center;
      position: absolute;
      top: 0; left: 0;
      z-index: 2;
      width: 100%; height: 100%;
      @include font(16, 400);
      color: #828A92;
      transition: all .3s;
      cursor: pointer;

      @include isMobile {
        @include font(14, 400);
      }

      & .iconfont {
        margin-right: 9px;
        @include isMobile {
          margin-right: 5px;
          margin-top: -2px;
          @include font(13, 400);
        }
      }
    }

    & .file-input {
      position: relative;
      width: 100%; height: 100%;
    }
  }
}
</style>
